import React from 'react';

import styled from '@emotion/styled';

interface IDispatchStatusComponent {
  children: string;
  noMenu?: boolean;
  tModalData?: any;
}

const DispatchStatusComponent: React.FC<IDispatchStatusComponent> = ({
  children,
}) => {
  const RenderedStatus = () => {
    if (children === 'PENDING') {
      return 'Pending';
    } else if (children === 'PICKING') {
      return 'Picking';
    } else if (children === 'PICKED') {
      return 'Picked';
    } else if (children === 'PICKLIST_CONFIRMED') {
      return 'Picklist Confirmed';
    } else if (children === 'OUT_FOR_DELIVERY') {
      return 'Out For Delivery';
    } else if (children === 'DISPATCHED') {
      return 'Dispatched';
    } else if (children === 'DELIVERED') {
      return 'Delivered';
    } else if (children === 'CLEARED') {
      return 'Cleared';
    } else if (children === 'INCUSTOMS') {
      return 'In Customs';
    } else if (children === 'IN_CUSTOMS') {
      return 'In Customs';
    } else if (children === 'RECEIVED') {
      return 'Received';
    } else if (children === 'PICKEDUP') {
      return 'Picked-up';
    } else if (children === 'AT_WAREHOUSE') {
      return 'At Warehouse';
    } else if (children === 'IN_WAREHOUSE') {
      return 'In Warehouse';
    }
  };
  return (
    <Container>
      <StatusDiv className={children}>{RenderedStatus()}</StatusDiv>
    </Container>
  );
};

export default DispatchStatusComponent;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

const StatusDiv = styled.div`
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  width: fit-content;
  text-transform: capitalize;
  font-size: 0.875rem;
  align-self: flex-start;

  &.CLEARED {
    color: #22b231;
    background-color: #ebf7ee;
  }
  &.PENDING {
    color: #f46f3b;
    background-color: #fef8f5;
  }
  &.INCUSTOMS {
    color: #139ab7;
    background-color: #f1fbfe;
  }
  &.RECEIVED {
    color: #22b231;
    background-color: #fef8f5;
  }
  &.PICKEDUP {
    color: #0f33f0;
    background-color: #ebf7ee;
  }
  &.DELIVERED {
    color: #22b231;
    background-color: #fef8f5;
  }
  &.OUT_FOR_DELIVERY {
    color: #139ab7;
    background-color: #fef8f5;
  }
  &.DISPATCHED {
    color: #0f33f0;
    background-color: #fef8f5;
  }
  &.PICKLIST_CONFIRMED {
    color: #22b231;
    background-color: #fef8f5;
  }
  &.PICKING {
    color: #139ab7;
    background-color: #fef8f5;
  }
  &.PICKED {
    color: #b77813;
    background-color: #fef8f5;
  }
  &.DELIVERED {
    color: #0f33f0;
    background-color: #fef8f5;
  }
  &.IN_CUSTOMS {
    color: #139ab7;
    background-color: #f1fbfe;
  }
  &.PICKEDUP {
    color: #0f33f0;
    background-color: #ebf7ee;
  }
  &.AT_WAREHOUSE {
    color: #22b231;
    background-color: #fef8f5;
  }

  &.IN_WAREHOUSE {
    color: #22b231;
    background-color: #fef8f5;
  }
`;
